import { mq } from '@phishtool/ui';
import styled from 'styled-components';
export const StyledSubNavHeading = styled.h2.withConfig({ displayName: "StyledSubNavHeading", componentId: "sc-1ome74" }) `
  position: fixed;
  top: 62px;
  z-index: 100;
  margin-left: 19px;
  font-weight: ${(props) => props.theme.fontWeights.bold};
  ${(props) => props.theme.responsiveFontsize.body.medium}

  ${(props) => mq({
    display: [props.isSubNavOpen ? 'block' : 'none', 'block'],
})}
`;
